import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CreateChancel } from 'components';
import { FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { clearHouseTypeEnums } from '../constants';

const ACTION_TYPE = 'CONNECT_INTEGRATION';

export const ConnectTherapyLake = () => {
    const { close } = useModal();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);
    const handleCreate = () => {
        dispatch(systemActions.connectIntegration({ clearinghouseType: clearHouseTypeEnums.TL_CLEARINGHOUSE }));
    };

    return (
        <div style={{ width: 400 }}>
            <div className="office-ally-header">
                <div className="office-ally-header-icons">
                    <div>
                        <img src={Images.logoSmall} alt="" />
                    </div>
                </div>
                <p>Connect to TL Clearinghouse</p>
            </div>

            <div style={{ marginTop: 24 }}>
                <CreateChancel
                    onCreate={handleCreate}
                    loader={!!loader.length}
                    create="Connect"
                    chancel="Cancel"
                    onClose={close}
                    buttonWidth="100%"
                />
            </div>
        </div>
    );
};
